import React from "react";
import s from "../TechSpec.module.scss";

const TableNotes = ({ children }) => (
  <div className={s.tableNotes}>{children}</div>
);

export default TableNotes;
